export default __webpack_public_path__ + "static/media/screen1.cef39fd6.png";